import React from 'react'
import {  useEffect, useState } from "react";
import {  getRandomNews } from './blog_data';


const RandomPosts = () => {


     const [randomPosts, setRandomPosts] = useState([]);
    
       useEffect(() => {
          
          async function fetchLatest() {
          
        
            const data = await getRandomNews();
            setRandomPosts(data);
          }
        
          fetchLatest();
        }, []);
  return (
    <div>



{randomPosts.map((newsItem) => (
             <div key={newsItem.id} className="border rounded-3 p-3 mb-4 mt-4">
               <h4>{newsItem.title}</h4>
               {/* <p>{newsItem.excerpt}</p> */}
            <div className="text-end">
            <button
                 onClick={() =>               window.location.href =  `/news/${newsItem?.slug}`
                }
                 className="btn btn-primary btn-outline"
               >
                 Read More
               </button>
            </div>
             </div>
           ))}

    </div>
  )
}

export default RandomPosts
